import { CrudMode, DataDisplay, formatDate, Grid, pn, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { DatePicker, Input, Select } from "components";
import { ProviderEmployment, ProviderEmploymentEditResource, ProviderEmploymentViewResource } from "generated/openApi";

import produce from "immer";
import "moment-timezone";

export const ProviderEmploymentPageBody = (props: {
  crudMode: CrudMode;
  employment: ProviderEmployment;
  setEmployment: (value: ProviderEmployment) => void;
  viewResource: ProviderEmploymentViewResource;
  editResource: ProviderEmploymentEditResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const schoolField = () => {
    const propertyName = pn<ProviderEmployment>("schoolId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.employment.school?.name}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.editResource.schools?.find((x) => x.id === props.employment.schoolId)}
        options={props.editResource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setEmployment(
            produce(props.employment, (draft) => {
              draft.schoolId = value?.id;
            })
          )
        }
      />
    );
  };

  const startDateField = () => {
    const propertyName = pn<ProviderEmployment>("startDate");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatDate(props.employment.startDate)}</DataDisplay>
    ) : (
      <DatePicker
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.employment.startDate}
        onChange={(value) =>
          props.setEmployment(
            produce(props.employment, (draft) => {
              draft.startDate = value;
            })
          )
        }
      />
    );
  };

  const endDateField = () => {
    const propertyName = pn<ProviderEmployment>("endDate");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatDate(props.employment.endDate)}</DataDisplay>
    ) : (
      <DatePicker
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.employment.endDate}
        onChange={(value) =>
          props.setEmployment(
            produce(props.employment, (draft) => {
              draft.endDate = value;
            })
          )
        }
      />
    );
  };

  const endReasonField = () => {
    const propertyName = pn<ProviderEmployment>("endReason");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.employment.endReason}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.employment.endReason}
        onChange={(e) =>
          props.setEmployment(
            produce(props.employment, (draft) => {
              draft.endReason = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {startDateField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {endDateField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {schoolField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {endReasonField()}
      </Grid>
    </Grid>
  );
};
